import { apply, put } from 'redux-saga/effects';
import {
  loadEmailReportsAction,
  createEmailReportAction,
  deleteEmailReportAction,
  updateEmailReportAction,
  loadEmailParamsAction,
} from '../reducers/email-reports.reducers';

import { LOCATION_ENTITY_NAME, JOBTYPE_REPORT } from '../models';


export function* loadEmailReports(emailReportsApi, { payload }) {
  const { locationId } = payload;

  const queryParams = {
    entityName: LOCATION_ENTITY_NAME,
    entityId: locationId,
    jobType: JOBTYPE_REPORT,
  };

  const response = yield apply(emailReportsApi, emailReportsApi.loadEmailReports, [queryParams]);
  if (response.errorCode) {
    yield put(loadEmailReportsAction.FAILED());
    return;
  }

  const emailReports = response.filter(x => x.jobType === JOBTYPE_REPORT);
  yield put(loadEmailReportsAction.DONE(emailReports));
}

export function* createEmailReport(emailReportsApi, { payload }) {
  const response = yield apply(emailReportsApi, emailReportsApi.createEmailReport, [payload]);

  if (response.errorCode) {
    yield put(createEmailReportAction.FAILED());
    return;
  }

  yield put(createEmailReportAction.DONE());
  yield put(loadEmailReportsAction.INIT({ locationId: response.entityId }));
}

export function* deleteEmailReport(emailReportsApi, { payload }) {
  const response = yield apply(emailReportsApi, emailReportsApi.deleteEmailReport, [payload]);
  if (response.errorCode) {
    yield put(deleteEmailReportAction.FAILED());
    return;
  }

  yield put(deleteEmailReportAction.DONE(payload));
}

export function* updateEmailReport(emailReportsApi, { payload }) {
  try {
    const response = yield apply(emailReportsApi, emailReportsApi.updateEmailReport, [payload]);
    if (response.errorCode) {
      throw response;
    }

    yield put(updateEmailReportAction.DONE());
    yield put(loadEmailReportsAction.INIT({ locationId: response.entityId }));
  } catch {
    yield put(updateEmailReportAction.FAILED());
  }
}

export function* loadEmailParams(emailReportsApi, { payload }) {
  const x = { ...payload, a: 'a' };

  const response = yield apply(emailReportsApi, emailReportsApi.loadParams, [x]);

  if (response.error || response.errorCode) {
    yield put(loadEmailParamsAction.FAILED());
    return;
  }

  yield put(loadEmailParamsAction.DONE(response));
}
